module.exports = __webpack_public_path__ + "static/media/Discover.71959a9b.svg";